import i18n from "./i18n";

export const isTamil = i18n.t("locale") === "ta-lk";
export const isSinhala = i18n.t("locale") === "si-lk";
export const isEnglish = i18n.t("locale") === "en-us";
